module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-check': _vm.notification.seenAt, 'text-success': _vm.notification.seenAt
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDateTime(_vm.notification.createdAt)))]), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.notificationText)
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "disabled": _vm.notificationTarget === null,
      "to": _vm.notificationTarget
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c4d2878"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notifications/NotificationListRow.vue
// module id = 517
// module chunks = 0